<template>
  <div class="rounded-md bg-white p-6 shadow-md">
    <div class="space-y-4">
      <h2 v-if="!isLoading" class="mb-2 text-center text-xl font-semibold text-gray-700">
        {{ tituloRecibo }} del comprobante nro. {{ recibo.numero_comprobante }}
      </h2>
      <transition
        enter-active-class="transition-opacity duration-300"
        leave-active-class="transition-opacity duration-300"
        enter-class="opacity-0"
        leave-to-class="opacity-0"
        mode="out-in"
      >
        <Cargando v-if="isLoading" key="1" />
        <Empty key="2" v-else-if="!recibo" />
        <div v-else key="3" ref="printContent">
          <div class="mx-auto max-w-lg rounded-xl border border-black p-4">
            <div class="flex justify-center px-2 py-1">
              <img class="mx-auto h-16" src="@/assets/logo-colescba.png" alt="Colescba" />
            </div>

            <div class="flex flex-col space-y-2">
              <div class="text-center">
                <div class="text-center text-xl font-semibold">
                  {{ tituloRecibo }}
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 text-center">
                <div v-if="recibo.nombre">
                  <div class="font-semibold text-gray-800">Apellido y nombres</div>
                  <div class="text-sm">{{ recibo.nombre }}</div>
                </div>
                <div v-if="recibo.carnet">
                  <div class="font-semibold text-gray-800">Carnet</div>
                  <div class="text-sm">{{ recibo.carnet }}</div>
                </div>
                <!-- <div>
                  <div class="font-semibold text-gray-800">Comprobante</div>
                  <div class="text-sm">{{ recibo.numero_comprobante }}</div>
                </div> -->
                <div>
                  <div class="font-semibold text-gray-800">Descripción</div>
                  <div class="text-sm">{{ recibo.descripcion }}</div>
                </div>
                <div>
                  <div class="font-semibold text-gray-800">Tipo de deuda</div>
                  <div class="text-sm">{{ recibo.tipo_deuda }}</div>
                </div>
                <div>
                  <div class="font-semibold text-gray-800">Monto</div>
                  <div class="text-sm">{{ recibo.monto | currency }}</div>
                </div>
                <div>
                  <div class="font-semibold text-gray-800">Fecha de pago</div>
                  <div class="text-sm">
                    {{ recibo.fecha_pago | dateTime('America/Buenos_Aires', 'DD-MM-Y H:mm') }}
                  </div>
                </div>
                <div>
                  <div class="font-semibold text-gray-800">Medio de pago</div>
                  <div class="text-sm">{{ recibo.medio_pago }}</div>
                </div>
                <div v-if="recibo.transaccion_id">
                  <div class="font-semibold text-gray-800">ID de transacción</div>
                  <div class="text-sm">{{ recibo.transaccion_id }}</div>
                </div>
              </div>
              <div v-if="esReciboPago" class="text-center font-bold text-gray-800">
                Comprobante válido de pago, consérvelo.
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition
        enter-active-class="transition-opacity duration-300"
        leave-active-class="transition-opacity duration-300"
        enter-class="opacity-0"
        leave-to-class="opacity-0"
        mode="out-in"
      >
        <div v-if="!isLoading" class="flex justify-center">
          <button
            class="mx-2 rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm transition duration-150 ease-in-out hover:bg-cool-gray-200 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 active:bg-cool-gray-200"
            @click="$router.go(-1)"
          >
            Volver
          </button>
          <button
            @click="imprimir"
            type="button"
            class="inline-flex items-center justify-center space-x-2 rounded-md border border-blue-brand-700 bg-blue-brand-500 px-3 py-2 text-sm font-medium text-blue-brand-100 transition duration-150 ease-in-out hover:bg-blue-brand-700 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 active:bg-blue-brand-700"
          >
            <SolidPrinterIcon class="h-6 w-6 text-blue-brand-100" />
            <span class="text-center text-sm font-bold">Imprimir</span>
          </button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { useService } from '@colescba/app-vue'
import { useSession } from '@colescba/ui'

import Cargando from '@/components/Core/Cargando'
import Empty from '@/components/Core/Empty'

export default {
  name: 'VerRecibo',

  components: { Cargando, Empty },

  mixins: [useService('portalPagos'), useSession()],

  props: {
    nroComprobante: { type: [String, Number], required: true },
  },

  data() {
    return {
      recibo: null,
      deuda: null,
      isLoading: true,
    }
  },

  computed: {
    tituloRecibo() {
      return this.esReciboPago ? 'Recibo de pago' : 'Talón de recepción de pago'
    },
    esReciboPago() {
      return this.deuda.pago.medio_pago.id.trim() == 'CTANOT'
    },
  },

  async mounted() {
    let response = await this.portalPagos.getDeudas(
      this.user.cuitCuil.numero,
      `filter_name:FN_DeudaxComprobante,nro_comprobante:${this.nroComprobante}`,
      'id:desc'
    )
    if (response.records.length == 0) {
      this.$toast.open({
        message: 'No se encontró el comprobante',
        type: 'error',
        duration: 2500,
        dismissible: true,
      })
      return this.$router.push({ name: 'comprobantes' })
    }
    this.deuda = response.records[0]
    if (!this.deuda?.pago) {
      this.$toast.open({
        message: 'No existe un pago registrado para el comprobante',
        type: 'error',
        duration: 2500,
        dismissible: true,
      })
      return this.$router.push({ name: 'comprobantes' })
    }
    this.recibo = await this.portalPagos.getRecibo(this.user.cuitCuil.numero, this.nroComprobante)
    this.isLoading = false
  },

  methods: {
    imprimir() {
      let printArea = document.getElementById('print-area')
      let printContent = this.$refs.printContent.innerHTML
      printArea.innerHTML = printContent
      window.print()
    },
  },
}
</script>
<style>
@media print {
  body {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}

@page {
  margin: 0.6cm;
}
</style>
